import { InteractionType } from "@azure/msal-browser";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { protectedResources } from "../authConfig"

export const HangfireFrame = () => {
    const { instance } = useMsal();
    const { result } = useMsalAuthentication(InteractionType.Redirect,
        {
            ...{ scopes: protectedResources.scopes.admin },
            account: instance.getActiveAccount(),
            redirectUri: '/redirect'
        });

    return <>
        <iframe src={protectedResources.apiHangfire.endpoint + '?jwt_token=' + result?.accessToken} style={{ height: "90vh", width: "100%" }}></iframe>
    </>;
}